import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const LoginContainer = ({ children }) => {
    return (_jsx("div", Object.assign({ className: "page--login" }, { children: _jsx("div", Object.assign({ className: "login-container" }, { children: children }), void 0) }), void 0));
};
export default LoginContainer;
